/**
 * Validation Messages Constants
 *
 * Centralized validation messages for form fields across the application.
 */

export const VALIDATION_MESSAGES = {
  REQUIRED: {
    EMAIL: 'Email is required',
    PASSWORD: 'Password is required',
    NAME: 'Name is required',
    MOBILE: 'Mobile number is required',
    EMPLOYEE_ID: 'Employee ID is required',
    DEPARTMENT: 'Department is required',
    PURPOSE: 'Purpose is required',
    OTP: 'OTP is required',
  },
  FORMAT: {
    EMAIL: 'Please enter a valid email address',
    EMAIL_DOMAIN: 'Email domain not allowed. Please use your corporate email.',
    MOBILE: 'Please enter a valid 10-digit mobile number',
    OTP: 'OTP must be 6 digits',
  },
  LENGTH: {
    NAME_MIN: 'Name must be at least 2 characters',
    NAME_MAX: 'Name must be less than 100 characters',
    PASSWORD_MIN: 'Password must be at least 8 characters',
    PASSWORD_MAX: 'Password must be no more than 30 characters',
    PURPOSE_MIN: 'Purpose must be at least 10 characters',
    PURPOSE_MAX: 'Purpose must be less than 500 characters',
  },
  SUCCESS: {
    SIGNUP_REQUEST: 'Signup request submitted successfully! Please wait for admin approval.',
    OTP_SENT: 'OTP sent to your email successfully',
    OTP_VERIFIED: 'OTP verified successfully',
    PASSWORD_RESET: 'Password reset successfully. Please login with your new password.',
  },
  ERROR: {
    SIGNUP_FAILED: 'Failed to submit signup request. Please try again.',
    OTP_INVALID: 'Invalid OTP. Please check and try again.',
    OTP_EXPIRED: 'OTP has expired. Please request a new one.',
    GENERAL: 'An unexpected error occurred. Please try again.',
  },
};
